export const endpointsMetadata = {
  workoutPlan: {
    getOrCreate: "/WorkoutPlan/GetOrCreate",
    createStandalone: "/WorkoutPlan/CreateStandalone",
    createUserStandalone: "/WorkoutPlan/CreateUserStandalone",
    getById: "/WorkoutPlan/GetById",
    delete: "/WorkoutPlan/Delete",
    updateName: "/WorkoutPlan/UpdateName",
    addExercise: "/WorkoutPlan/AddExercise",
    addExerciseByName: "/WorkoutPlan/AddExerciseByName",
    removeExercise: "/WorkoutPlan/RemoveExercise",
    updateExerciseNotes: "/WorkoutPlan/UpdateExerciseNotes",
    updateExerciseRestTimer: "/WorkoutPlan/UpdateExerciseRestTimer",
    updateExerciseUseAutomaticTimer: "/WorkoutPlan/UpdateExerciseUseAutomaticTimer",
    updateExerciseSupersetLetter: "/WorkoutPlan/UpdateExerciseSupersetLetter",
    updateExerciseType: "/WorkoutPlan/UpdateExerciseType",
    updateExerciseResistanceBand: "/WorkoutPlan/UpdateExerciseResistanceBand",
    updateExerciseSection: "/WorkoutPlan/UpdateExerciseSection",
    updateExerciseDistanceUnit: "/WorkoutPlan/UpdateExerciseDistanceUnit",
    updateExerciseMuscleGroups: "/WorkoutPlan/UpdateExerciseMuscleGroups",
    addSet: "/WorkoutPlan/AddSet",
    updateSet: "/WorkoutPlan/UpdateSet",
    removeSet: "/WorkoutPlan/RemoveSet",
    toggleSetCompleted: "/WorkoutPlan/ToggleSetCompleted",
    getUserWorkouts: "/WorkoutPlan/GetUserWorkouts",
    getUserWorkoutsDetailed: "/WorkoutPlan/GetUserWorkoutsDetailed",
    getUserWorkoutStatistics: "/WorkoutPlan/GetUserWorkoutStatistics",
    getUserWorkoutAchievements: "/WorkoutPlan/GetUserWorkoutAchievements",
    getMyWorkouts: "/WorkoutPlan/GetMyWorkouts",
    getMyWorkoutStatistics: "/WorkoutPlan/GetMyWorkoutStatistics",
    getMyWorkoutAchievements: "/WorkoutPlan/GetMyWorkoutAchievements",
    hasMyWorkouts: "/WorkoutPlan/HasMyWorkouts",
    loadTemplate: "/WorkoutPlan/LoadTemplate",
    reorderExercises: "/WorkoutPlan/ReorderExercises",
  },
  workingHours: {
    saveWorkingHours: "/WorkingHours/SaveWorkingHours",
    getStudioWorkingHours: "/WorkingHours/GetStudioWorkingHours/studio",
    getUserWorkingHours: "/WorkingHours/GetUserWorkingHours/user",
  },
  website: {
    submitContact: "/website/contact",
    submitDemoRequest: "/website/demo-request",
    getCategories: "/website/categories",
    checkEmail: "/website/check-email",
    checkDomain: "/website/check-domain",
    checkPhone: "/website/check-phone",
    validatePromocode: "/website/validate-promocode",
    createStudio: "/website/create-studio",
    track: "/website/track",
  },
  userAuditLog: {
    getUserHistory: "/UserAuditLog/GetUserHistory",
    getDetail: "/UserAuditLog/GetDetail",
  },
  user: {
    getUser: "/User/GetUser",
    getUserPlan: "/User/GetUserPlan",
    wizardGetClient: "/User/WizardGetClient",
    getAll: "/User/GetAll",
    getNotes: "/User/GetNotes",
    addNote: "/User/AddNote",
    updateNote: "/User/UpdateNote",
    deleteNote: "/User/DeleteNote",
    wizard: "/User/Wizard",
    toggleReliabilityStatus: "/User/ToggleReliabilityStatus",
    confirmUserEmail: "/User/ConfirmUserEmail",
    putUserBack: "/User/PutUserBack",
    deleteUser: "/User/DeleteUser",
    deleteUserForever: "/User/DeleteUserForever",
    getMergePreview: "/User/GetMergePreview",
    mergeUsers: "/User/MergeUsers",
  },
  tenant: {
    getTenant: "/Tenant/GetTenant",
    wizardGetTenant: "/Tenant/WizardGetTenant",
    getAll: "/Tenant/GetAll",
    getNotes: "/Tenant/GetNotes",
    addNote: "/Tenant/AddNote",
    updateNote: "/Tenant/UpdateNote",
    deleteNote: "/Tenant/DeleteNote",
    wizard: "/Tenant/Wizard",
    putTenantBack: "/Tenant/PutTenantBack",
    putStudioBack: "/Tenant/PutStudioBack",
    deleteStudio: "/Tenant/DeleteStudio",
    deleteTenant: "/Tenant/DeleteTenant",
  },
  supportChat: {
    getAll: "/SupportChat/GetAll",
    getChat: "/SupportChat/GetChat",
    create: "/SupportChat/Create",
    sendMessage: "/SupportChat/SendMessage",
    uploadAttachment: "/SupportChat/UploadAttachment",
    closeChat: "/SupportChat/CloseChat",
    reopenChat: "/SupportChat/ReopenChat",
    getUnreadCount: "/SupportChat/GetUnreadCount",
  },
  studioRelations: {
    getAllConnections: "/StudioRelations/GetAllConnections",
    getAllEligibleStudios: "/StudioRelations/GetAllEligibleStudios",
    addStudioConnection: "/StudioRelations/AddStudioConnection",
  },
  qrRedirect: {
    resolve: "/q",
  },
  studioQrCode: {
    getAll: "/StudioQrCode/GetAll",
    create: "/StudioQrCode/Create",
    update: "/StudioQrCode/Update",
    delete: "/StudioQrCode/Delete",
    transfer: "/StudioQrCode/Transfer",
  },
  studioLinkPage: {
    getPage: "/StudioLinkPage/GetPage",
    getPublicPage: "/StudioLinkPage/GetPublicPage",
    addItem: "/StudioLinkPage/AddItem",
    updateItem: "/StudioLinkPage/UpdateItem",
    deleteItem: "/StudioLinkPage/DeleteItem",
    reorder: "/StudioLinkPage/Reorder",
  },
  studioAuditLog: {
    getStudioHistory: "/StudioAuditLog/GetStudioHistory",
    getDetail: "/StudioAuditLog/GetDetail",
    recordGlobalAdminAccess: "/StudioAuditLog/RecordGlobalAdminAccess",
    recordGlobalAdminExit: "/StudioAuditLog/RecordGlobalAdminExit",
    getMyStudioAccessLog: "/StudioAuditLog/GetMyStudioAccessLog",
  },
  studio: {
    getStudioInstructors: "/Studio/GetStudioInstructors",
    getStudioEmployeesSimplified: "/Studio/GetStudioEmployeesSimplified",
    getStudioSettings: "/Studio/GetStudioSettings",
    getAll: "/Studio/GetAll",
    getStudio: "/Studio/GetStudio",
    wizardGetStudio: "/Studio/WizardGetStudio",
    uploadLogo: "/Studio/UploadLogo",
    deleteLogo: "/Studio/DeleteLogo",
    getAvailableTenants: "/Studio/GetAvailableTenants",
    wizard: "/Studio/Wizard",
    rehireEmployee: "/Studio/RehireEmployee",
    putBackStudio: "/Studio/PutBackStudio",
    resignEmployee: "/Studio/ResignEmployee",
    deleteStudio: "/Studio/DeleteStudio",
    deleteStudioForever: "/Studio/DeleteStudioForever",
    invalidateCorsCache: "/Studio/InvalidateCorsCache",
  },
  statistics: {
    getAllEmployees: "/Statistics/GetAllEmployees",
    generateStatistics: "/Statistics/GenerateStatistics",
  },
  portalReviews: {
    getMine: "/PortalReviews/GetMine",
    saveMine: "/PortalReviews/SaveMine",
  },
  publicReviews: {
    getSummary: "/PublicReviews/GetSummary",
    getPage: "/PublicReviews/GetPage",
    getInvite: "/PublicReviews/GetInvite",
    submitWithInvite: "/PublicReviews/SubmitWithInvite",
  },
  studioReviews: {
    getAll: "/StudioReviews/GetAll",
    setHidden: "/StudioReviews/SetHidden",
    reply: "/StudioReviews/Reply",
    getSettings: "/StudioReviews/GetSettings",
    updateSettings: "/StudioReviews/UpdateSettings",
  },
  preReservationForm: {
    getActiveOptions: "/PreReservationForm/GetActiveOptions",
    getForEvent: "/PreReservationForm/GetForEvent",
    getForService: "/PreReservationForm/GetForService",
    getSubmissionByUserEvent: "/PreReservationForm/GetSubmissionByUserEvent",
  },
  clientForm: {
    getUserSubmissions: "/ClientForm/GetUserSubmissions",
    getSubmissionContent: "/ClientForm/GetSubmissionContent",
    sendForm: "/ClientForm/SendForm",
    getSentForm: "/ClientForm/GetSentForm",
    submitSentForm: "/ClientForm/SubmitSentForm",
  },
  serviceEmployeePortfolio: {
    getPortfolio: "/ServiceEmployeePortfolio/GetPortfolio",
    upload: "/ServiceEmployeePortfolio/Upload",
    delete: "/ServiceEmployeePortfolio/Delete",
  },
  portalCalendar: {
    getAll: "/PortalCalendar/GetAll",
    getEvent: "/PortalCalendar/GetEvent",
    reserve: "/PortalCalendar/Reserve",
    eligiblePlans: "/PortalCalendar/EligiblePlans",
    eligiblePlansForWaitingList: "/PortalCalendar/EligiblePlansForWaitingList",
    getReservationDetails: "/PortalCalendar/GetReservationDetails",
    cancelStripeReservation: "/PortalCalendar/CancelStripeReservation",
    confirmWaitingListSpot: "/PortalCalendar/ConfirmWaitingListSpot",
    confirmWaitingListSpotAndPay: "/PortalCalendar/ConfirmWaitingListSpotAndPay",
  },
  myReservations: {
    getAll: "/MyReservations/GetAll",
    cancelReservation: "/MyReservations/CancelReservation",
  },
  myPlans: {
    getAll: "/MyPlans/GetAll",
    hasActivePlan: "/MyPlans/HasActivePlan",
  },
  myFamily: {
    getCurrentUserFamily: "/MyFamily/GetCurrentUserFamily",
    wizardGetFamilyData: "/MyFamily/WizardGetFamilyData",
    updateFamily: "/MyFamily/UpdateFamily",
    createUser: "/MyFamily/CreateUser",
    initialFamilyCreation: "/MyFamily/InitialFamilyCreation",
  },
  myConsents: {
    getAll: "/MyConsents/GetAll",
    giveConsent: "/MyConsents/GiveConsent",
  },
  musicSuggestions: {
    searchTracks: "/MusicSuggestions/SearchTracks",
    getTracks: "/MusicSuggestions/GetTracks",
    getSuggestions: "/MusicSuggestions/GetSuggestions",
    addSuggestion: "/MusicSuggestions/AddSuggestion",
    deleteSuggestion: "/MusicSuggestions/DeleteSuggestion",
    toggleUpvote: "/MusicSuggestions/ToggleUpvote",
  },
  groupClasses: {
    getAvailableClasses: "/GroupClasses/classes",
    getInstructors: "/GroupClasses/instructors",
    getFamilyMembers: "/GroupClasses/family-members",
    getFamilyMembersWithStatus: "/GroupClasses/family-members-with-status",
    getBulkAvailability: "/GroupClasses/bulk-availability",
    reserve: "/GroupClasses/reserve",
  },
  calendarDownload: {
    reservation: "/CalendarDownload/Reservation",
  },
  appointments: {
    getAvailableServices: "/Appointments/services",
    getAvailableEmployees: "/Appointments/employees",
    getEmployeePortfolio: "/Appointments/employees/portfolio",
    getAvailableTimeSlots: "/Appointments/availability",
    getBulkAvailableTimeSlots: "/Appointments/bulk-availability",
    appointmentWizard: "/Appointments/wizard",
    getAppointmentDetails: "/Appointments",
    validateTimeSlot: "/Appointments/validate-slot",
  },
  planner: {
    getEvent: "/Planner/GetEvent",
    getSignUpEventData: "/Planner/GetSignUpEventData",
    meetingLinkRecipientsWithoutEmail: "/Planner/MeetingLinkRecipientsWithoutEmail",
    getAll: "/Planner/GetAll",
    getTenantSettings: "/Planner/GetTenantSettings",
    getAvailableEventUsersWihoutDeleted: "/Planner/GetAvailableEventUsersWihoutDeleted",
    getAllRelatedEventsById: "/Planner/GetAllRelatedEventsById",
    getAssignableEventsForInstructor: "/Planner/GetAssignableEventsForInstructor",
    bulkAssignInstructor: "/Planner/BulkAssignInstructor",
    getDeletableEvents: "/Planner/GetDeletableEvents",
    bulkDeleteEvents: "/Planner/BulkDeleteEvents",
    wizardGetInitialData: "/Planner/WizardGetInitialData",
    wizardGetEventTemplates: "/Planner/WizardGetEventTemplates",
    wizard: "/Planner/Wizard",
    classConflicts: "/Planner/ClassConflicts",
    serviceWizard: "/Planner/ServiceWizard",
    blockedTimeWizard: "/Planner/BlockedTimeWizard",
    sentEventEmail: "/Planner/SentEventEmail",
    registerForEvent: "/Planner/RegisterForEvent",
    getEventNotes: "/Planner/GetEventNotes",
    addEventNote: "/Planner/AddEventNote",
    addUserEventNote: "/Planner/AddUserEventNote",
    updateEventNote: "/Planner/UpdateEventNote",
    updateUserEventNote: "/Planner/UpdateUserEventNote",
    deleteEventNote: "/Planner/DeleteEventNote",
    deleteUserEventNote: "/Planner/DeleteUserEventNote",
    permanentlyDeleteUserEvent: "/Planner/PermanentlyDeleteUserEvent",
    bulkPermanentlyDeleteUserEvents: "/Planner/BulkPermanentlyDeleteUserEvents",
    deregisterFromEvent: "/Planner/DeregisterFromEvent",
    reRegisterForEvent: "/Planner/ReRegisterForEvent",
    getEventArrivalConfirmationInfo: "/Planner/GetEventArrivalConfirmationInfo",
    markUserAsArrived: "/Planner/MarkUserAsArrived",
    markUserAsNotArrived: "/Planner/MarkUserAsNotArrived",
    markReservationAsPenaltyCancelled: "/Planner/MarkReservationAsPenaltyCancelled",
    toggleConfirmReservation: "/Planner/ToggleConfirmReservation",
    addPaymentMethod: "/Planner/AddPaymentMethod",
    removePaymentMethod: "/Planner/RemovePaymentMethod",
    toggleFormFulfillment: "/Planner/ToggleFormFulfillment",
    putBackEvent: "/Planner/PutBackEvent",
    deleteEvent: "/Planner/DeleteEvent",
    deleteEventForever: "/Planner/DeleteEventForever",
    getEventIdByReservationId: "/Planner/GetEventIdByReservationId",
    getHandoverDay: "/Planner/GetHandoverDay",
    addHandoverEntry: "/Planner/AddHandoverEntry",
    deleteHandoverEntry: "/Planner/DeleteHandoverEntry",
    markHandoverDayAsRead: "/Planner/MarkHandoverDayAsRead",
  },
  plan: {
    getPlan: "/Plan/GetPlan",
    getAll: "/Plan/GetAll",
    wizardGetInitialData: "/Plan/WizardGetInitialData",
    wizard: "/Plan/Wizard",
    wizardRefillCardInitialData: "/Plan/WizardRefillCardInitialData",
    refillCard: "/Plan/RefillCard",
    getCardRenewalOptions: "/Plan/GetCardRenewalOptions",
    renewCard: "/Plan/RenewCard",
    toggleSubscriptionDeletionStatus: "/Plan/ToggleSubscriptionDeletionStatus",
    deletePlan: "/Plan/DeletePlan",
    deletePlanForever: "/Plan/DeletePlanForever",
    putBackPlan: "/Plan/PutBackPlan",
  },
  stripeConnect: {
    getConnectUrl: "/payments/stripe-connect/connect-url",
    refresh: "/payments/stripe-connect/refresh",
    getStatus: "/payments/stripe-connect/status",
    disconnect: "/payments/stripe-connect/disconnect",
  },
  stripeWebhook: {
    connectWebhook: "/payments/stripe/webhook",
    platformWebhook: "/payments/stripe/webhook/platform",
  },
  onboarding: {
    getPendingItems: "/Onboarding/GetPendingItems",
    completeItem: "/Onboarding/CompleteItem",
  },
  notificationPreferences: {
    get: "/NotificationPreferences/Get",
    update: "/NotificationPreferences/Update",
  },
  pushNotifications: {
    publicKey: "/PushNotifications/PublicKey",
    subscribe: "/PushNotifications/Subscribe",
    unsubscribe: "/PushNotifications/Unsubscribe",
    delivered: "/PushNotifications/Delivered",
    opened: "/PushNotifications/Opened",
  },
  restTimerAlarm: {
    schedule: "/RestTimerAlarm/Schedule",
    cancel: "/RestTimerAlarm/Cancel",
  },
  breakTypeNomenclature: {
    getAll: "/nomenclature/BreakTypeNomenclature/GetAll",
    getAllWithDeleted: "/nomenclature/BreakTypeNomenclature/GetAllWithDeleted",
    getById: "/nomenclature/BreakTypeNomenclature/GetById",
    create: "/nomenclature/BreakTypeNomenclature/Create",
    update: "/nomenclature/BreakTypeNomenclature/Update",
    toggleDeletionStatus: "/nomenclature/BreakTypeNomenclature/ToggleDeletionStatus",
  },
  eventTypeCategoryNomenclature: {
    getAll: "/nomenclature/EventTypeCategoryNomenclature/GetAll",
    getAllWithDeleted: "/nomenclature/EventTypeCategoryNomenclature/GetAllWithDeleted",
    getById: "/nomenclature/EventTypeCategoryNomenclature/GetById",
    create: "/nomenclature/EventTypeCategoryNomenclature/Create",
    update: "/nomenclature/EventTypeCategoryNomenclature/Update",
    toggleDeletionStatus: "/nomenclature/EventTypeCategoryNomenclature/ToggleDeletionStatus",
    reorder: "/nomenclature/EventTypeCategoryNomenclature/Reorder",
  },
  exerciseNomenclature: {
    getAll: "/nomenclature/ExerciseNomenclature/GetAll",
    getById: "/nomenclature/ExerciseNomenclature/GetById",
    create: "/nomenclature/ExerciseNomenclature/Create",
    update: "/nomenclature/ExerciseNomenclature/Update",
    toggleDeletionStatus: "/nomenclature/ExerciseNomenclature/ToggleDeletionStatus",
    search: "/nomenclature/ExerciseNomenclature/Search",
  },
  inventoryItemNomenclature: {
    getAll: "/nomenclature/InventoryItemNomenclature/GetAll",
    getAllWithDeleted: "/nomenclature/InventoryItemNomenclature/GetAllWithDeleted",
    getById: "/nomenclature/InventoryItemNomenclature/GetById",
    create: "/nomenclature/InventoryItemNomenclature/Create",
    update: "/nomenclature/InventoryItemNomenclature/Update",
    toggleDeletionStatus: "/nomenclature/InventoryItemNomenclature/ToggleDeletionStatus",
    reorderItems: "/nomenclature/InventoryItemNomenclature/ReorderItems",
    getAllCategories: "/nomenclature/InventoryItemNomenclature/GetAllCategories",
    getAllCategoriesWithDeleted: "/nomenclature/InventoryItemNomenclature/GetAllCategoriesWithDeleted",
    getCategoryById: "/nomenclature/InventoryItemNomenclature/GetCategoryById",
    createCategory: "/nomenclature/InventoryItemNomenclature/CreateCategory",
    updateCategory: "/nomenclature/InventoryItemNomenclature/UpdateCategory",
    toggleCategoryDeletionStatus: "/nomenclature/InventoryItemNomenclature/ToggleCategoryDeletionStatus",
    reorderCategories: "/nomenclature/InventoryItemNomenclature/ReorderCategories",
    getAllCategorized: "/nomenclature/InventoryItemNomenclature/GetAllCategorized",
    searchProducts: "/nomenclature/InventoryItemNomenclature/SearchProducts",
    adjustQuantity: "/nomenclature/InventoryItemNomenclature/AdjustQuantity",
    getItemNotes: "/nomenclature/InventoryItemNomenclature/GetItemNotes",
    addItemNote: "/nomenclature/InventoryItemNomenclature/AddItemNote",
    updateItemNote: "/nomenclature/InventoryItemNomenclature/UpdateItemNote",
    deleteItemNote: "/nomenclature/InventoryItemNomenclature/DeleteItemNote",
  },
  inventoryTransfers: {
    getAll: "/InventoryTransfers/GetAll",
    getAllWithDeleted: "/InventoryTransfers/GetAllWithDeleted",
    getById: "/InventoryTransfers/GetById",
    create: "/InventoryTransfers/Create",
    update: "/InventoryTransfers/Update",
    toggleDeletionStatus: "/InventoryTransfers/ToggleDeletionStatus",
    getTransferHistory: "/InventoryTransfers/GetTransferHistory",
    getHistoryDetail: "/InventoryTransfers/GetHistoryDetail",
    getTransferNotes: "/InventoryTransfers/GetTransferNotes",
    addTransferNote: "/InventoryTransfers/AddTransferNote",
    updateTransferNote: "/InventoryTransfers/UpdateTransferNote",
    deleteTransferNote: "/InventoryTransfers/DeleteTransferNote",
  },
  preReservationFormNomenclature: {
    getAll: "/nomenclature/PreReservationFormNomenclature/GetAll",
    getAllWithDeleted: "/nomenclature/PreReservationFormNomenclature/GetAllWithDeleted",
    getById: "/nomenclature/PreReservationFormNomenclature/GetById",
    create: "/nomenclature/PreReservationFormNomenclature/Create",
    update: "/nomenclature/PreReservationFormNomenclature/Update",
    toggleDeletionStatus: "/nomenclature/PreReservationFormNomenclature/ToggleDeletionStatus",
  },
  serviceTypeNomenclature: {
    getAll: "/nomenclature/ServiceTypeNomenclature/GetAll",
    getNomenclatureAdditionalData: "/nomenclature/ServiceTypeNomenclature/GetNomenclatureAdditionalData",
    getAllWithDeleted: "/nomenclature/ServiceTypeNomenclature/GetAllWithDeleted",
    getById: "/nomenclature/ServiceTypeNomenclature/GetById",
    create: "/nomenclature/ServiceTypeNomenclature/Create",
    update: "/nomenclature/ServiceTypeNomenclature/Update",
    toggleDeletionStatus: "/nomenclature/ServiceTypeNomenclature/ToggleDeletionStatus",
    reorderItems: "/nomenclature/ServiceTypeNomenclature/ReorderItems",
    getAllCategories: "/nomenclature/ServiceTypeNomenclature/GetAllCategories",
    getAllCategoriesWithDeleted: "/nomenclature/ServiceTypeNomenclature/GetAllCategoriesWithDeleted",
    getCategoryById: "/nomenclature/ServiceTypeNomenclature/GetCategoryById",
    createCategory: "/nomenclature/ServiceTypeNomenclature/CreateCategory",
    updateCategory: "/nomenclature/ServiceTypeNomenclature/UpdateCategory",
    toggleCategoryDeletionStatus: "/nomenclature/ServiceTypeNomenclature/ToggleCategoryDeletionStatus",
    reorderCategories: "/nomenclature/ServiceTypeNomenclature/ReorderCategories",
    getAllCategorized: "/nomenclature/ServiceTypeNomenclature/GetAllCategorized",
  },
  studioHallTypeNomenclature: {
    getAll: "/nomenclature/StudioHallTypeNomenclature/GetAll",
    getAllWithDeleted: "/nomenclature/StudioHallTypeNomenclature/GetAllWithDeleted",
    getById: "/nomenclature/StudioHallTypeNomenclature/GetById",
    create: "/nomenclature/StudioHallTypeNomenclature/Create",
    update: "/nomenclature/StudioHallTypeNomenclature/Update",
    toggleDeletionStatus: "/nomenclature/StudioHallTypeNomenclature/ToggleDeletionStatus",
  },
  studioPlanTypesNomenclature: {
    getAll: "/nomenclature/StudioPlanTypesNomenclature/GetAll",
    getAllWithDeleted: "/nomenclature/StudioPlanTypesNomenclature/GetAllWithDeleted",
    getById: "/nomenclature/StudioPlanTypesNomenclature/GetById",
    create: "/nomenclature/StudioPlanTypesNomenclature/Create",
    update: "/nomenclature/StudioPlanTypesNomenclature/Update",
    toggleDeletionStatus: "/nomenclature/StudioPlanTypesNomenclature/ToggleDeletionStatus",
  },
  napAudit: {
    generate: "/NapAudit/Generate",
    documents: "/NapAudit/Documents",
    updateDocuments: "/NapAudit/UpdateDocuments",
    backfillDocuments: "/NapAudit/BackfillDocuments",
  },
  myNapSettings: {
    getMyNapSettings: "/MyNapSettings/GetMyNapSettings",
    updateMyNapSettings: "/MyNapSettings/UpdateMyNapSettings",
  },
  myBusiness: {
    getMyBusiness: "/MyBusiness/GetMyBusiness",
    updateMyBusiness: "/MyBusiness/UpdateMyBusiness",
  },
  mcp: {
    generateToken: "/Mcp/GenerateToken",
    getTokens: "/Mcp/GetTokens",
    revokeToken: "/Mcp/RevokeToken",
  },
  invoice: {
    getForTenant: "/Invoice/GetForTenant",
    generatePaymentLink: "/Invoice/GeneratePaymentLink",
    getAutoPayStatus: "/Invoice/GetAutoPayStatus",
    setAutoPay: "/Invoice/SetAutoPay",
    downloadInvoice: "/Invoice/DownloadInvoice",
  },
  inventoryOverview: {
    getExpiringBatches: "/InventoryOverview/GetExpiringBatches",
    getProductsByQuantity: "/InventoryOverview/GetProductsByQuantity",
  },
  inventoryAuditLog: {
    getItemHistory: "/InventoryAuditLog/GetItemHistory",
    getDetail: "/InventoryAuditLog/GetDetail",
  },
  googleMeet: {
    getStatus: "/integrations/google-meet/status",
    getConnectUrl: "/integrations/google-meet/connect-url",
    connect: "/integrations/google-meet/connect",
    disconnect: "/integrations/google-meet/disconnect",
  },
  initialization: {
    getUserStudios: "/Initialization/GetUserStudios",
    getVersion: "/Initialization/GetVersion",
  },
  gym: {
    searchUsers: "/Gym/SearchUsers",
    checkInOrOut: "/Gym/CheckInOrOut",
    currentlyInside: "/Gym/CurrentlyInside",
    stats: "/Gym/Stats",
    history: "/Gym/History",
    forceCheckOut: "/Gym/ForceCheckOut",
    lastActionForUser: "/Gym/LastActionForUser",
    revertLastAction: "/Gym/RevertLastAction",
    setRfidBand: "/Gym/SetRfidBand",
  },
  goal: {
    getUserGoals: "/Goal/GetUserGoals",
    addUserGoal: "/Goal/AddUserGoal",
    editUserGoal: "/Goal/EditUserGoal",
    deleteUserGoal: "/Goal/DeleteUserGoal",
    reorderUserGoals: "/Goal/ReorderUserGoals",
    setUserGoalCompleted: "/Goal/SetUserGoalCompleted",
    getMyGoals: "/Goal/GetMyGoals",
    setMyGoalCompleted: "/Goal/SetMyGoalCompleted",
  },
  classFlag: {
    setClassFlag: "/ClassFlag/SetClassFlag",
  },
  giftVoucher: {
    getAll: "/GiftVoucher/GetAll",
    getById: "/GiftVoucher/GetById",
    create: "/GiftVoucher/Create",
    update: "/GiftVoucher/Update",
    toggleDeletionStatus: "/GiftVoucher/ToggleDeletionStatus",
    sendEmail: "/GiftVoucher/SendEmail",
    getSellable: "/GiftVoucher/GetSellable",
    lookupByCode: "/GiftVoucher/LookupByCode",
    assignHolder: "/GiftVoucher/AssignHolder",
  },
  family: {
    getAll: "/Family/GetAll",
    getFamily: "/Family/GetFamily",
    getAllAvailableUsers: "/Family/GetAllAvailableUsers",
    wizardGetFamily: "/Family/WizardGetFamily",
    getNotes: "/Family/GetNotes",
    addNote: "/Family/AddNote",
    updateNote: "/Family/UpdateNote",
    deleteNote: "/Family/DeleteNote",
    wizard: "/Family/Wizard",
    deleteFamilyForever: "/Family/DeleteFamilyForever",
    putFamilyBack: "/Family/PutFamilyBack",
    deleteFamily: "/Family/DeleteFamily",
  },
  eventAuditLog: {
    getEventHistory: "/EventAuditLog/GetEventHistory",
    getDetail: "/EventAuditLog/GetDetail",
  },
  employee: {
    getEmployee: "/Employee/GetEmployee",
    getAll: "/Employee/GetAll",
    wizardGetEmployee: "/Employee/WizardGetEmployee",
    getEmployeeServices: "/Employee/GetEmployeeServices",
    wizard: "/Employee/Wizard",
    putEmployeeBack: "/Employee/PutEmployeeBack",
    deleteEmployee: "/Employee/DeleteEmployee",
    deleteEmployeeForever: "/Employee/DeleteEmployeeForever",
  },
  domains: {
    isAllowed: "/domains/allowed",
  },
  deposit: {
    getHistory: "/Deposit/GetHistory",
    topUp: "/Deposit/TopUp",
    withdraw: "/Deposit/Withdraw",
  },
  dashboard: {
    getMetrics: "/Dashboard/GetMetrics",
    getMetricDetail: "/Dashboard/GetMetricDetail",
    disableMetric: "/Dashboard/DisableMetric",
    enableMetric: "/Dashboard/EnableMetric",
  },
  communicationLogs: {
    getEmailLogs: "/CommunicationLogs/GetEmailLogs",
    getEmailLogUsers: "/CommunicationLogs/GetEmailLogUsers",
    getEmailLogDetail: "/CommunicationLogs/GetEmailLogDetail",
    cancelEmail: "/CommunicationLogs/CancelEmail",
    retryEmail: "/CommunicationLogs/RetryEmail",
    getSmsLogs: "/CommunicationLogs/GetSmsLogs",
    getSmsLogUsers: "/CommunicationLogs/GetSmsLogUsers",
    getPushLogs: "/CommunicationLogs/GetPushLogs",
    getPushLogUsers: "/CommunicationLogs/GetPushLogUsers",
    cancelSms: "/CommunicationLogs/CancelSms",
    sendMassEmail: "/CommunicationLogs/SendMassEmail",
    sendTestEmail: "/CommunicationLogs/SendTestEmail",
    sendMassSms: "/CommunicationLogs/SendMassSms",
  },
  base: {
  },
  cashdesk: {
    createOrder: "/Cashdesk/CreateOrder",
    getOrders: "/Cashdesk/GetOrders",
    getOrderById: "/Cashdesk/GetOrderById",
    toggleDeletionStatus: "/Cashdesk/ToggleDeletionStatus",
    searchCustomers: "/Cashdesk/SearchCustomers",
  },
  bodyMetric: {
    getUserBodyMetrics: "/BodyMetric/GetUserBodyMetrics",
    addUserBodyMetric: "/BodyMetric/AddUserBodyMetric",
    deleteUserBodyMetric: "/BodyMetric/DeleteUserBodyMetric",
    getMyBodyMetrics: "/BodyMetric/GetMyBodyMetrics",
    addMyBodyMetric: "/BodyMetric/AddMyBodyMetric",
    deleteMyBodyMetric: "/BodyMetric/DeleteMyBodyMetric",
  },
  authentication: {
    getAllPolicies: "/Authentication/GetAllPolicies",
    login: "/Authentication/Login",
    impersonationLogin: "/Authentication/ImpersonationLogin",
    setNewPassword: "/Authentication/SetNewPassword",
    setPhoneNumber: "/Authentication/SetPhoneNumber",
    validatePasswordToken: "/Authentication/ValidatePasswordToken",
    forgottenPassword: "/Authentication/ForgottenPassword",
    checkPhoneNumber: "/Authentication/CheckPhoneNumber",
    sendPasswordSetEmail: "/Authentication/SendPasswordSetEmail",
    generatePasswordResetLink: "/Authentication/GeneratePasswordResetLink",
    googleCallbackBridge: "/Authentication/GoogleCallbackBridge/GoogleCallbackBridge",
    sendRegistrationCode: "/Authentication/SendRegistrationCode",
    sendFirstLoginCode: "/Authentication/SendFirstLoginCode",
    verifyEmailCode: "/Authentication/VerifyEmailCode",
    resendVerificationCode: "/Authentication/ResendVerificationCode",
    getUserProfile: "/Authentication/GetUserProfile/GetUserProfile",
    updateMyProfile: "/Authentication/UpdateMyProfile",
    changePassword: "/Authentication/ChangePassword",
    uploadProfilePhoto: "/Authentication/UploadProfilePhoto",
    logFrontendError: "/Authentication/LogFrontendError",
  },
  announcement: {
    getPending: "/Announcement/GetPending",
    markSeen: "/Announcement/MarkSeen",
  },
  announcementImage: {
    get: "/AnnouncementImage/api/announcement-images",
  },
  aiAssistant: {
    getStatus: "/AiAssistant/GetStatus",
    getConversations: "/AiAssistant/GetConversations",
    getConversation: "/AiAssistant/GetConversation",
    deleteConversation: "/AiAssistant/DeleteConversation",
    uploadImage: "/AiAssistant/UploadImage",
    send: "/AiAssistant/Send",
    createSupportTicket: "/AiAssistant/CreateSupportTicket",
  },
};
